import React, { useMemo } from 'react'
import { rem } from 'polished'
import styled from 'styled-components'
import { buildRoomPackageOptionsViewOrder } from 'lib/offer/offerPageUtil'
import type { OfferPageState } from 'contexts/OfferPage/offerPageStateReducer'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import { getDurationPackageOptions } from 'selectors/offerPage/offerPageSelectors'
import Group from 'components/utils/Group'
import ModalBody from 'LuxKit/Modal/ModalBody'
import BodyText from 'LuxKit/Typography/BodyText'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import Pane from 'components/Common/Pane'
import { useIntl } from 'react-intl'
import { InOfferFlowContext } from '../RoomOptionsContext'
import FlashMobileStickyHeaderFilters from '../FlashMobileStickyHeaderFilters'
import FlashHotelMobileSameRoomOptions from '../FlashHotelMobileSameRoomOptions'

const OptionsContainer = styled.div`
  padding: ${rem(12)} ${rem(20)};
`

interface Props {
  packageOptions: Array<App.OfferPackageOptionView>
  onBack?: () => void
  onClose: () => void
  cheapestSelectedOption?: App.OfferPackageOptionView
}

function FlashHotelRoomSelectionModal(props: Props) {
  const {
    packageOptions,
    onBack,
    onClose,
  } = props

  const intl = useIntl()
  const packageOptionsByRoom = useMemo(() => {
    return buildRoomPackageOptionsViewOrder(packageOptions)
  }, [packageOptions])

  const modalTitle = intl.formatMessage({
    id: '+10I7Fi6YM',
    defaultMessage: 'Select a room',
    description: 'Title for room selection modal',
  })

  const availableRoomsText = intl.formatMessage(
    {
      id: '7q6Tm4xXt4',
      defaultMessage: '{count, plural, one {# room type} other {# room types}} available',
      description: 'Text showing number of room types available',
    },
    {
      count: packageOptionsByRoom.length,
    },
  )

  return (
    <>
      <ModalHeader
        title={modalTitle}
        onCloseButtonClick={onClose}
        onBackButtonClick={onBack}
      >
        <FlashMobileStickyHeaderFilters />
      </ModalHeader>
      <ModalBody>
        <InOfferFlowContext.Provider value={false}>
          <Group direction="vertical">
            {packageOptionsByRoom.length > 1 && (
              <OptionsContainer>
                <BodyText variant="small" colour="neutral-three">{availableRoomsText}</BodyText>
              </OptionsContainer>
            )}
            <Pane background="neutral-six">
              <FlashHotelMobileSameRoomOptions showSelection={false} />
            </Pane>
          </Group>
        </InOfferFlowContext.Provider>
      </ModalBody>
    </>
  )
}

export default withOfferPageAndReduxState((state: OfferPageState, appState: App.State) => ({
  rooms: state.rooms,
  packageOptions: getDurationPackageOptions(state, appState),
}), FlashHotelRoomSelectionModal)
